module.exports = __webpack_public_path__ + "static/media/wand.2bfd18cb.svg";